<div class="absolute inset-x-0 top-0 z-99999" *ngIf="isBusy$ | async">
    <mat-progress-bar [mode]="'indeterminate'"></mat-progress-bar>
</div>
<router-outlet></router-outlet>
